import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCurrentLineBookingStatusCode = createSelector(
  (state: Store) => state.dealManagement.commonDeal.currentLine.bookingStatusCode,
  (bookingStatusCode) => bookingStatusCode,
);
